import Header from "./Header";
import { ModalConfirmationProvider } from "@/context/ModalConfirmationContext";
import { ModalProvider } from "@/context/ModalContext";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { cn } from "@/utils/cn";
import { useLayout } from "@/context/LayoutContext";

function Layout() {
  const { isFullPage } = useLayout();

  return (
    <ModalProvider>
      <ModalConfirmationProvider>
        <div
          className={cn(
            isFullPage ? "h-screen" : "",
            "flex w-full overflow-hidden !pb-6"
          )}
        >
          <Sidebar />
          <div className="flex-1 gap-y-2 flex flex-col border-s overflow-hidden">
            <Header />
            <main className="flex-1 flex p-6 pb-4 pt-1 overflow-x-auto overflow-y-hidden">
              <div className="w-full">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      </ModalConfirmationProvider>
    </ModalProvider>
  );
}

export default Layout;
